import { React, useState, useEffect } from 'react';
import { MotifIcon, MotifTooltip } from '@ey-xd/motif-react';
import { actionIcInfoOutline24px } from '@ey-xd/motif-react/assets/icons';
import {
  CardTitleThree,
  DataCardContainerPL,
  TitleContainerThree,
  DataContainerTwo,
  Value,
  Separator,
  LabelLineThree,
} from '../../../../atoms/dashboard/personalDashboard.styles';
import { DATA_CARD_THREE, QUARTERLY_DETAILS } from '../../../../../constants/commonConstants';
import { processNumber } from '../../../../../util/commonUtil';

const DataCardThree = data => {
  const [openCloseDuration, setOpenCloseDuration] = useState();

  useEffect(async () => {
    if (!!data && data != null && data != undefined) {
      setOpenCloseDuration(data.data);
    }
  }, [data]);

  return (
    !!openCloseDuration && (
      <DataCardContainerPL>
        <TitleContainerThree>
          <CardTitleThree>{DATA_CARD_THREE.TITLE}</CardTitleThree>
          <MotifTooltip
            id="bottom"
            trigger={
              <MotifIcon
                src={actionIcInfoOutline24px}
                style={{ width: '16px', height: '16px', margintop: '3px' }}
              ></MotifIcon>
            }
            allowHover={true}
            allowClick={true}
            placement="bottom"
          >
            The time it takes for an opportunity to be <br /> Won from the moment it is Opened in
            the
            <br /> system. For example, if an opportunity is <br /> Opened and Won in the same week,
            it will <br /> be captured in this metric.
          </MotifTooltip>
        </TitleContainerThree>
        <DataContainerTwo>
          <Value>
            {openCloseDuration.Seven_days !== null
              ? processNumber(openCloseDuration.Seven_days) + '%'
              : QUARTERLY_DETAILS.TBD}
          </Value>
          <LabelLineThree>{DATA_CARD_THREE.LABLE_ONE}</LabelLineThree>
        </DataContainerTwo>
        <Separator />
        <DataContainerTwo>
          <Value>
            {openCloseDuration.Thirty_days !== null
              ? processNumber(openCloseDuration.Thirty_days) + '%'
              : QUARTERLY_DETAILS.TBD}
          </Value>
          <LabelLineThree>{DATA_CARD_THREE.LABLE_TWO}</LabelLineThree>
        </DataContainerTwo>
        <Separator />
        <DataContainerTwo>
          <Value>
            {openCloseDuration.Ninety_days !== null
              ? processNumber(openCloseDuration.Ninety_days) + '%'
              : QUARTERLY_DETAILS.TBD}
          </Value>
          <LabelLineThree>{DATA_CARD_THREE.LABLE_THREE}</LabelLineThree>
        </DataContainerTwo>
      </DataCardContainerPL>
    )
  );
};

export default DataCardThree;
